/**
 * 1-联系我们
 * 2-服务保障
 * 18-客户案例
 * 4-市场活动
 * 5-常见问题
 * 6-产业课堂
 * 7-产品定价
 * 8-客户反馈
 * 9-侧边栏
 * 10-更多产品
 * 12-客户案例广告
 * 13-产业课堂广告
 * 14-市场活动广告
 * 15-标杆案例
 * 16-合作故事
 * 17-标杆案例广告
 * 18-新客户案例-列表
 * 19-新客户案例广告
*/
export default {
  freeUse: {
    moduleType: 1,
    moduleName: '联系我们',
    isMenu: false
  },
  service: {
    moduleType: 2,
    moduleName: '服务保障',
    isMenu: false
  },
  example: {
    moduleType: 18,
    moduleName: '客户案例',
    isMenu: true
  },
  marketActivity: {
    moduleType: 4,
    moduleName: '市场活动',
    isMenu: true
  },
  question: {
    moduleType: 5,
    moduleName: '常见问题',
    isMenu: false
  },
  industryClass: {
    moduleType: 6,
    moduleName: '产业课堂',
    isMenu: true
  },
  productPrice: {
    moduleType: 7,
    moduleName: '产品定价',
    isMenu: true
  },
  feedback: {
    moduleType: 8,
    moduleName: '客户反馈',
    isMenu: false
  },
  sidebar: {
    moduleType: 9,
    moduleName: '侧边栏',
    isMenu: false
  },
  more: {
    moduleType: 10,
    moduleName: '更多产品',
    isMenu: false
  },
  footer: {
    moduleType: 11,
    moduleName: '底部栏',
    isMenu: false
  },
  benchmarkExample: {
    moduleType: 15,
    moduleName: '标杆案例',
    isMenu: true
  },
  benchmarkStory: {
    moduleType: 16,
    moduleName: '合作故事',
    isMenu: false
  }
}
